import { render } from "./FriendEdit.vue?vue&type=template&id=2fb1c19b"
import script from "./FriendEdit.vue?vue&type=script&lang=js"
export * from "./FriendEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__